import React from 'react'
import { removeWigStyle } from '../utils/metafieldService';
import { User } from '../types/User';

export function WigRemovalPopup({ user, id, buttonAction, close }: { user: User, id: string, buttonAction: Function, close: Function }) {
  async function remove() {
    await removeWigStyle({ user, id })
    buttonAction()
  }
  return <>
    <div className="bg-black/[0.25] fixed inset-0 z-20" onClick={() => close()}></div>
    <div className="text-center fixed z-20 left-4 right-4 top-1/2 -translate-y-2/4 bg-white pt-12 px-4 pb-20 drop-shadow-cartItem max-w-[600px] mx-auto">
      <h3 className="mb-8 mx-auto">Are you sure you want to delete <br /> this style from your profile?</h3>
      <button className="bg-black text-white uppercase px-2 py-4 text-xl w-full mt-16 max-w-[480px] mx-auto block font-semibold" onClick={() => remove()}>Yes</button>
      <a className="block mt-5 cursor-pointer" onClick={() => close()}>No</a>
    </div>
  </>
}
